import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Pill } from 'ui-components/components/pill';
import Global from '../../../../store/global-selectors';
import classnames from 'clsx';
import { messages } from '../../messages';
import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

export const InheritedTags = ({ tagIds = emptyArray }) => {
  const sellerTags = useSelector(Global.selectSellerTags);
  const tags = sellerTags.filter((tag) => tagIds.includes(tag.tagId));
  const noTags = tagIds.length === 0;
  return (
    <div className={classnames(style['tags-list'], { [style.empty]: noTags })}>
      {noTags && <FormattedMessage {...messages.defaultPresetGroupText} />}
      {tags.map((tag) => (
        <Pill key={tag.tagId} className={style['inherited-pill']} collapsed color={tag.hexColor} label={tag.name} theme='tag' />
      ))}
    </div>
  );
};

InheritedTags.propTypes = {
  tagIds: PropTypes.arrayOf(PropTypes.string),
};
